<template lang="pug">
a.contact(v-bind:class="{ hidden: isActive }", @click="toggle()"): span お問い合わせはこちら
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["isActive"]),
  },
  methods: {
    ...mapMutations(["toggleForm"]),
    toggle() {
      this.toggleForm();
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../../assets/stylesheets/variables";

.contact {
  padding: $space-m $space-l;
  border-radius: 100px;
  background-color: $bg-secondary;
  position: fixed;
  bottom: $space-m;
  right: $space-m;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  text-decoration: none;
  visibility: visible;
  font-weight: bold;
  color: #fff;
  opacity: 1;
  transition: all 0.3s ease-in-out 0.3s;
  @media only screen and( max-width: 768px) {
    width: 50px;
    height: 50px;
    padding: 0;
    border-radius: 100%;
  }
  &:before {
    padding-right: $space-s;
    position: relative;
    font-family: "Ionicons";
    content: "\f2eb";
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #fff;
    font-weight: bold;
    @media only screen and( max-width: 768px) {
      padding-right: 0;
    }
  }
  & > span {
    @media only screen and( max-width: 768px) {
      display: none;
    }
  }
}
.hidden {
  visibility: hidden;
  transition: all 0.3s ease-in-out 0.3s;
  opacity: 0;
}
</style>
